import { createRootRoute, Outlet } from '@tanstack/react-router';
import { BuildInfo } from '@/components/build-info';
import { ToastProvider } from '@/components/toaster';
import { AppError, RouteNotFound } from '@/components/route-error';
import { reportRenderError } from '@/lib/rum';

// Root layout: the page frame + the active route's outlet + the always-on
// release banner. Auth gating lives on the child routes (cockpit redirects to
// /login when there's no session).
function RootLayout() {
  return (
    <ToastProvider>
      <div className="bg-background text-foreground min-h-dvh">
        <Outlet />
        <BuildInfo />
      </div>
    </ToastProvider>
  );
}

// Answers for whatever no route below claimed, which is what keeps the
// library's own fallback unreachable — in a production build that renders one
// unstyled sentence and a button revealing nothing.
export const rootRoute = createRootRoute({
  component: RootLayout,
  errorComponent: AppError,
  onCatch: (error) => reportRenderError(error, 'route:root'),
  notFoundComponent: RouteNotFound,
});
